import { AfterViewInit, ChangeDetectorRef, Component, OnInit, ViewChild, ElementRef, Output, EventEmitter, OnDestroy } from '@angular/core';
import { AbstractControl, FormBuilder, FormGroup, NgForm, ValidationErrors, ValidatorFn, Validators } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { DatePipe } from '@angular/common'
import { config } from 'src/app/config/config';
import { UserDetailsService } from 'src/app/service/user-details.service';
import { ToastrService } from 'ngx-toastr';
import { catchError } from 'rxjs/operators';
import { Subject, throwError } from 'rxjs';
import { Title } from '@angular/platform-browser';
declare var $: any;

import { NgxSpinnerService } from 'ngx-spinner';

import { toWords } from 'src/app/shared/toWords';
import { SgrbService } from 'src/app/service/sgrb.service';
import { ForexDerivativesService } from 'src/app/service/forex-derivatives.service';

@Component({
  selector: 'app-add-deal',
  templateUrl: './add-deal.component.html',
  styleUrls: ['./add-deal.component.css']
})
export class AddDealComponent {

  //form init
  tradeForm: FormGroup = this.formBuilder.group({});
  tradeFormData: any = [];
  optionStyle = ['Buy', 'Sell'];

  approvalFlag:any='';

  config: any = config;
  message: string;
  userDetails: any;
  user: any = {};
  entityType: any;
  entityCode: any;
  entityName: any;
  todayDate: Date = new Date();
  t1Date: Date = new Date();

  sgrbTrdId = '';
  action: string = 'newOrder';
  counterPartyData: any = [];
  bsValue: any[] = [];
  subscription: any;
  dtTrigger: Subject<any> = new Subject<any>();
  dtOptions: any;
  toWords = toWords;

  constructor(private formBuilder: FormBuilder,
    private route: ActivatedRoute,
    private userService: UserDetailsService,
    private userDetailsService: UserDetailsService,
    private router: Router,
    private toastr: ToastrService,
    private cdref: ChangeDetectorRef,
    private titleService: Title,
    private datePipe: DatePipe,
    private spinner: NgxSpinnerService,
    private sgrbService: SgrbService,
    private fsService: ForexDerivativesService

  ) {
    this.route.queryParams.subscribe(params => {
      if (params['id']) {
        this.sgrbTrdId = params['id'];
      }
      if (params['action']) {
        this.action = params['action'];
      }
    });

  }


  ngOnInit(): void {
    this.titleService.setTitle('Sovereign Green Bond');
    this.user = this.userDetailsService.getUserDetails() || {};
    this.entityType = this.user.entityType;
    this.entityCode = this.user.entityCode;
    this.entityName = this.user.loginId;
    this.t1Date.setDate(this.todayDate.getDate() + 1);
    this.getCounterPartyData();
    if (this.sgrbTrdId) {
      this.getSgrbTrade();
    }
    this.setSgrbForm();
   


  }

  get f() {
    return this.tradeForm.controls;
  }

  setSgrbForm() {
    this.tradeForm = this.formBuilder.group({
      orderId: [this.tradeFormData?.orderId || ''],
      tradeNumber: [this.tradeFormData?.tradeNumber || ''],
      reportingMemName: [this.tradeFormData?.reportingMemName || this.entityName, [Validators.required]],
      reportingMemId: [this.tradeFormData?.reportingMemId || this.entityCode, [Validators.required]],
      dealStatus: [this.tradeFormData?.dealStatus || 'Submitted', [Validators.required]],
      countrPartyName: [this.tradeFormData?.countrPartyName || '', [Validators.required]],
      countrPartyId: [this.tradeFormData?.countrPartyId || '', [Validators.required]],
      trdDate: [{ value: this.tradeFormData?.trdDate ? new Date(this.tradeFormData?.trdDate) : new Date(), disabled: false }, [Validators.required]],
      trdTime: [{ value: this.tradeFormData?.trdTime ? new Date(this.tradeFormData?.trdTime) : new Date(), disabled: false }, [Validators.required]],
      txnRefId: [this.tradeFormData?.txnRefId || ''], //[this.tradeFormData?.txnRefId || null, [Validators.required, Validators.minLength(2), Validators.maxLength(16), Validators.pattern('^[a-zA-Z0-9]*$')]],
      optStyle: ['Buy', [Validators.required]],
      baseCrncyCode: [{ value: this.tradeFormData?.baseCrncyCode || 'USD', disabled: true }, [Validators.required]],
      trmCrncyCode: [{ value: this.tradeFormData?.trmCrncyCode || 'INR', disabled: true }, [Validators.required]],
      orderPrice: [this.tradeFormData?.orderPrice || 0, [Validators.required]],
      qty: [this.tradeFormData?.qty || 0, [Validators.required, this.nonNegativeValidator()]],
      trdValue: [{ value: this.tradeFormData?.trdValue || 0, disabled: true }, [Validators.required]],
      settlementDate: [this.tradeFormData?.settlementDate ? new Date(this.tradeFormData?.settlementDate) : '', [Validators.required]],
      remark: [this.tradeFormData?.remark || ''],
      processingSatus: [this.tradeFormData?.processingSatus || 'P', [Validators.required]],
      comment: [this.tradeFormData?.comment || ''],
      reqCrtBy: [this.tradeFormData?.reqCrtBy || ''],
      reqCrtDt: [this.tradeFormData?.reqCrtDt || ''],
      reqModifdBy: [this.tradeFormData?.reqModifdBy || ''],
      reqModifdDt: [this.tradeFormData?.reqModifdDt || '']


    });

    if (this.sgrbTrdId)
      this.action =
        (this.tradeFormData?.dealStatus == 'Submitted' && this.tradeFormData.countrPartyId == this.entityCode) ? 'approval' :
          (this.tradeFormData?.dealStatus == 'Submitted' && this.tradeFormData.reportingMemId == this.entityCode) ? 'edit' :
            'viewOrder';


    switch (this.action) {
      case 'edit':
        break;
      case 'approval':
        this.tradeForm.disable();
        this.tradeForm.get('comment').enable();
        break;
      case 'newOrder':
        break;
      default:
        this.tradeForm.disable();
        break;
    }

  }

  onApproval(approval: any) {
    this.f.processingSatus.setValue(approval == 'A' ? 'A' : 'R');
    this.approvalFlag = approval;
  }
  getSgrbTrade() {

    this.sgrbService.getSgrbTrade(this.sgrbTrdId).pipe(
      catchError((error: any) => {
        this.toastr.error(this.config.failureResponse["SOMETHING_WENT_WRONG"]);
        this.tradeFormData = [];
        this.setSgrbForm();
        if (error.status != 200) {
          return throwError(error.error);
        }
      })
    ).subscribe((response: any) => {
      if (response.statusCode == 200) {
        this.tradeFormData = response.data;
        this.setSgrbForm();
      } else {
        this.tradeFormData = {};
        this.setSgrbForm();
      }
    })

  }

  getCounterPartyData() {
    this.fsService.getCounterPartyListInterbank().pipe(
      catchError((error: any) => {
        this.spinner.hide();
        if (error.statusCode != 200) {
          this.toastr.error(error.message);
        }
        return throwError(error.error)
      })
    ).subscribe((response: any) => {
      if (response.statusCode == 200) {
        let counterParty = response.data;
        this.counterPartyData = counterParty//.filter(item => item.entityCode != this.entityCode);
      }
      this.cdref.detectChanges();
      $('.selectpicker').selectpicker('refresh');
    })
  }

  onSubmit() {
    this.sgrbService.submitTrade(this.tradeForm.getRawValue()).pipe(
      catchError((error: any) => {
        this.toastr.error(this.config.failureResponse.SOMETHING_WENT_WRONG);
        if (error.status != 200) {
          return throwError(error.error);
        }
      })
    ).subscribe(
      (response: any) => {
        if (response.statusCode == 200) {
          this.router.navigate(['/sovereignGreenBond/sgrb/']);
          this.toastr.success("SGrB Order Placed Successfully!!");
        }
        else {
          this.toastr.error(response.message);
        }
      })
  }
  computeTradeValue() {
    this.f.trdValue.setValue(this.f.orderPrice.value * this.f.qty.value);
  }

  selectCounterParty() {
    let counterParty = this.counterPartyData.find(data => data.userName == this.f.countrPartyName.value)
    this.f.countrPartyName.setValue(counterParty.userName);
    this.f.countrPartyId.setValue(counterParty.entityCode);
  }

  nonNegativeValidator(): ValidatorFn {
    return (control: AbstractControl): { [key: string]: any } | null => {
      if (control.value != null && control.value < 0) {
        return { 'negativeValue': { value: control.value } }
      }
      return null;
    };
  }
}

